export default class ProductReview extends HTMLElement {
	constructor() {
		super();
		this.id = this.dataset.productId;
		this.data = null;
		this.globalRange = null;
		this.maxStars = 5;
		this.globalStarsElement = this.querySelector('[data-global-stars]');
		this.keyBazaarvoice = this.dataset.keyBazaarvoice;
		this.keyTranslation = this.dataset.keyTranslation;
		this.locale = this.dataset.locale;
		this.customerEmail = this.dataset.customerEmail;
		this.customerId = this.dataset.customerId;
		this.accountMandatory = this.dataset.accountMandatory === 'true';
		this.sortBy = this.dataset.sortBy === 'rating';
		this.dateUserExperience = this.dataset.dateUserExperience === 'true';
		this.widgetBvapi = this.dataset.widgetBvapi === 'true';
		this.widgetCampaignId = this.dataset.widgetcampaignId;

		this.globalRangeElement = [...this.querySelectorAll('[data-global-range]')];
		this.elFriendRecommendation = this.querySelector(
			'[data-friend-recommendation]',
		);
		this.elFriendPourcent = this.querySelector('[data-friend-pourcent]');
		this.totalReviewCount = null;
		this.totalReviewCountElement = [
			...this.querySelectorAll('[data-total-review]'),
		];

		this.ratingDistribution = null;
		this.ratingDistributionElement = [
			...this.querySelectorAll('[data-rating-distribution]'),
		];
		this.reviews = null;
		this.elementReview = this.querySelector('[data-reviews]');

		this.paginationElement = this.querySelector('[data-pagination]');
		this.paginationNextElement = this.querySelector('[data-pagination-next]');
		this.paginationPrevElement = this.querySelector('[data-pagination-prev]');

		this.toggleFormReviewElement = this.querySelector(
			'[data-toggle-form-review]',
		);
		this.formNeedAccount = this.querySelector('[data-form-need-account]');
		this.formReview = this.querySelector('[data-form-review]');
		this.formReviewStars = this.querySelector('[data-form-review-stars]');

		this.reviewsStars = document.querySelector('[data-review-stars]');

		this.error = this.querySelector('[data-error]');
		this.success = this.querySelector('[data-success]');
	}

	async connectedCallback() {
		this.data = await this.fetchProductReviews();
		if (this.data) {
			this.render();
		}
	}

	async fetchProductReviews(offset = 0) {
		const URL_BZ = new URL('https://api.bazaarvoice.com/data/reviews.json');
		URL_BZ.searchParams.append('apiversion', '5.4');
		URL_BZ.searchParams.append('passkey', this.keyBazaarvoice);
		URL_BZ.searchParams.append('Filter', `ProductId:${this.id}`);
		URL_BZ.searchParams.append('Limit', 5);
		URL_BZ.searchParams.append('Offset', offset);
		URL_BZ.searchParams.append('Include', 'Products');
		URL_BZ.searchParams.append('Stats', 'Reviews');

		if (this.sortBy) {
			URL_BZ.searchParams.append('Sort', 'Rating:desc');
		} else {
			URL_BZ.searchParams.append('Sort', `ContentLocale:${this.locale}`);
		}

		const response = await fetch(URL_BZ);
		if (!response.ok) {
			console.error('Something went wrong');
			return null;
		}
		return await response.json();
	}

	async fetchProductReviewsWithFilterRanking(ranking, offset = 0) {
		const response = await fetch(
			`https://api.bazaarvoice.com/data/reviews.json?apiversion=5.4&passkey=${this.keyBazaarvoice}&Filter=ProductId:${this.id}&Sort=Rating:desc&Limit=5&Offset=${offset}&Include=Products&Stats=Reviews&Filter=Rating:eq:${ranking}`,
		);
		if (!response.ok) {
			console.error('Something went wrong');
			return null;
		}
		return await response.json();
	}

	async fetchHelpfulnessReview(vote, contentId) {
		const response = await fetch(
			`https://api.bazaarvoice.com/data/submitfeedback.json?apiversion=5.4&passkey=${this.keyBazaarvoice}&ContentType=review&ContentId=${contentId}&FeedbackType=helpfulness&Vote=${vote}`,
			{
				method: 'POST',
			},
		);
		if (!response.ok) {
			console.error('Something went wrong');
			return null;
		}
		return await response.json();
	}

	async fetchFormReviewFirstStep(data) {
		let param_url = '';
		if (!this.accountMandatory)
			param_url = '&apiVersion=5.4&action=submit&hostedauth=true';

		const body = {
			locale: `${this.locale}`,
			productIds: [`${this.id}`],
		};

		if (this.accountMandatory) body.userId = `${this.customerId}`;

		const response = await fetch(
			`https://api.bazaarvoice.com/data/initiateSubmit.json?ApiVersion=5.4&PassKey=${this.keyBazaarvoice}${param_url}`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(body),
			},
		);
		if (!response.ok) {
			console.error('Something went wrong');
			return null;
		}
		return await response.json();
	}

	async fetchFormReviewSecondStep(firstStepResponse, data) {
		let param_url = '';
		if (!this.accountMandatory)
			param_url = '&apiVersion=5.4&action=submit&hostedauth=true';

		const body = {
			locale: `${this.locale}`,
			submissionSessionToken:
				firstStepResponse.response.productFormData[`${this.id}`]
					.submissionSessionToken,
			productId: `${this.id}`,
			deviceFingerprint: this.querySelector('#ioBlackBox').value,
			useremail: `${data.get('email')}`,
			submissionFields: {
				agreedtotermsandconditions: 'true',
				reviewtext: `${data.get('content')}`,
				usernickname: `${data.get('userName')}`,
				contextdatavalue_Age: `${data.get('age')}`,
				contextdatavalue_TypeOfSkin: `${data.get('skinConcern')}`,
				contextdatavalue_Efficacy_1: `${data.get('efficacy')}`,
				contextdatavalue_Texture: `${data.get('texture')}`,
				contextdatavalue_Parfum: `${data.get('parfum')}`,
				rating: parseInt(data.get('rating')),
				title: `${data.get('title')}`,
			},
		};

		const value_incentivized = data.get('incentivized') === 'True';
		if (value_incentivized) {
			body.submissionFields.contextdatavalue_IncentivizedReview = `True`;
		}

		if (this.dateUserExperience) {
			body.submissionFields.additionalfield_DateOfUserExperience = `${data.get(
				'dateOfUserExperience',
			)}`;
		}

		body.userId = this.accountMandatory
			? `${this.customerId}`
			: firstStepResponse.response.userId;

		if (!this.accountMandatory) {
			body.submissionFields.hostedauthentication_authenticationemail = `${data.get(
				'email',
			)}`;
			body.submissionFields.hostedauthentication_callbackurl =
				window.location.href;
		}

		const response = await fetch(
			`https://api.bazaarvoice.com/data/progressiveSubmit.json?ApiVersion=5.4&PassKey=${this.keyBazaarvoice}${param_url}`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(body),
			},
		);
		if (!response.ok) {
			console.error('Something went wrong');
			return await response.json();
		}
		return await response.json();
	}

	render() {
		if (this.data.Results.length === 0) {
			// no reviews
			this.hideStars();
			this.toggleReviewForm();
			this.makeRankingFormReview();
			this.listenSubmitForm();
		} else {
			this.initData();
			this.createStarsElement();
			this.createRatingDistributionElement();
			this.globalRangeElement.forEach((el) => {
				el.innerHTML = this.globalRange;
			});
			this.totalReviewCountElement.forEach((el) => {
				el.innerHTML = this.totalReviewCount;
			});

			this.displayFriendRecommendations();
			this.createGlobalStarsElement();
			this.createReviewElement();

			this.listenRatingDistribution();
			this.createPaginationElement();
			this.listenBtnPagination();

			this.toggleReviewForm();
			this.makeRankingFormReview();
			this.listenSubmitForm();

			this.listenSubmitFormHelpfulness();
			this.listenTranslateReview();
		}
	}

	initData() {
		// init data
		this.totalReviewCount = this.data.TotalResults;
		this.globalRange =
			this.data.Includes.Products[
				this.id
			].ReviewStatistics.AverageOverallRating.toFixed(1);
		this.ratingDistribution =
			this.data.Includes.Products[this.id].ReviewStatistics.RatingDistribution;
		this.reviews = this.data.Results;

		this.updateStructuredData();
	}

	/*
	 *
	 * updateStructuredData
	 * update Structured Data after page load
	 *
	 */
	updateStructuredData() {
		let productSchema = document.querySelector('#product-structured-data');

		if (productSchema?.firstChild) {
			const jsonProdSchem = JSON.parse(productSchema.firstChild.nodeValue);

			// Vérification de la présence des avis
			const hasReviews = this.totalReviewCount > 0;

			if (hasReviews) {
				// Si des avis existent, ajouter ratingValue et reviewCount
				jsonProdSchem.aggregateRating = {
					'@type': 'AggregateRating',
					ratingValue: this.globalRange,
					reviewCount: this.totalReviewCount,
				};
			}

			// Mettre à jour le contenu du script avec le nouveau JSON (sans bloc aggregateRating si pas d'avis)
			productSchema.firstChild.nodeValue = JSON.stringify(jsonProdSchem);
		}
	}

	createStarsElement() {
		const nbrStars = this.reviewsStars.querySelector('[data-review-stars-nbr]');
		const insideStars = this.reviewsStars.querySelector('[data-full-stars]');
		const pourcentage = 100 - (this.globalRange / this.maxStars) * 100;
		insideStars.style.clipPath = `inset(0 ${pourcentage}% 0 0)`;
		nbrStars.innerHTML = this.totalReviewCount;
	}

	createRatingDistributionElement() {
		this.ratingDistribution.forEach((els, index) => {
			this.ratingDistributionElement.forEach((el) => {
				if (els.RatingValue === parseInt(el.dataset.id, 10)) {
					const nbr = el.querySelector('[data-rating-distribution-nbr]');
					const bg = el.querySelector('[data-rating-distribution-bg]');
					const btn = el.querySelector('button');
					btn.disabled = false;
					const percentage = (els.Count / this.totalReviewCount) * 100;
					nbr.innerHTML = percentage.toFixed(0);
					bg.style.width = `${percentage}%`;
				}
			});
		});
	}

	listenRatingDistribution() {
		this.ratingDistributionElement.forEach((el) => {
			const btn = el.querySelector('button');
			btn.addEventListener('click', async () => {
				this.ratingDistributionElement.forEach((el) => {
					btn.classList.remove('u-font-bold');
				});
				btn.classList.add('u-font-bold');

				const ranking = el.dataset.id;
				this.data = await this.fetchProductReviewsWithFilterRanking(ranking);
				if (this.data) {
					this.initData();
					this.createReviewElement();
					this.createPaginationElement(ranking, true);
					this.listenBtnPagination(ranking, true);
					this.listenSubmitFormHelpfulness();
					this.listenTranslateReview();
				}
			});
		});
	}

	displayFriendRecommendations() {
		const {RecommendedCount, TotalReviewCount} =
			this.data.Includes.Products[this.id].ReviewStatistics;
		if (this.elFriendRecommendation) {
			this.elFriendRecommendation.classList.remove('u-hidden');
			const percentage = ((RecommendedCount / TotalReviewCount) * 100).toFixed(
				0,
			);

			if (RecommendedCount > 0) {
				this.elFriendPourcent.innerHTML = `${percentage}%`;
			} else {
				this.elFriendPourcent.innerHTML = '0%';
			}
		}
	}

	createGlobalStarsElement() {
		const pourcentage = 100 - (this.globalRange / this.maxStars) * 100;
		const fullStars =
			this.globalStarsElement.querySelector('[data-full-stars]');
		fullStars.style.clipPath = `inset(0 ${pourcentage}% 0 0)`;
	}

	createReviewElement() {
		this.elementReview.innerHTML = '';

		// Function to convert string to PascalCase
		function toPascalCase(str) {
			return str.replace(
				/\w+/g,
				(w) => w[0].toUpperCase() + w.slice(1).toLowerCase(),
			);
		}
		this.reviews.forEach(async (review) => {
			let reviewTitle = review.Title;
			let reviewTexte = review.ReviewText;
			let reviewSkin = review.ContextDataValues.TypeOfSkin?.ValueLabel;
			let reviewAge = review.ContextDataValues.Age?.ValueLabel;
			let {Value: reviewDateExpValue, Label: reviewDateExpLabel} =
				review.AdditionalFields.DateOfUserExperience || {};

			// reviewNeedTranslate turn true if local and review locale are differents
			const reviewNeedTranslate =
				this.locale.slice(0, 2) !== review.ContentLocale.slice(0, 2) &&
				this.keyTranslation;

			const pourcentage = 100 - (review.Rating / this.maxStars) * 100;

			const drawStarEmpty = () => {
				// SVG for empty star
				let stars = '';
				for (let i = 0; i < 5; i++) {
					stars += `<svg
					width='13.5'
					height='13.5'
					viewBox='0 0 22 22'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
					>
					<path d="M11.2327 17.1824L11 17.0601L10.7673 17.1824L5.05148 20.1874L6.14311 13.8227L6.18755 13.5637L5.99931 13.3802L1.3751 8.87268L7.76561 7.94408L8.02574 7.90628L8.14208 7.67056L11 1.87978L13.8579 7.67056L13.9743 7.90628L14.2344 7.94408L20.6249 8.87268L16.0007 13.3802L15.8125 13.5637L15.8569 13.8227L16.9485 20.1874L11.2327 17.1824Z" stroke="#F7B604"/>
					</svg>`;
				}
				return stars;
			};

			const drawStarFull = () => {
				// SVG for full star
				let stars = '';
				for (let i = 0; i < 5; i++) {
					stars += `<svg
						width='13.5'
						height='13.5'
						viewBox='0 0 22 22'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
						>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M11 17.625L4.38742 21.1014L5.65031 13.7382L0.300614 8.52356L7.69371 7.44928L11 0.75L14.3063 7.44928L21.6994 8.52356L16.3497 13.7382L17.6126 21.1014L11 17.625Z" fill="#F7B604"/>
						</svg>`;
				}
				return stars;
			};

			const reviewStars = (pourcentage) => {
				return `
				<div class='u-flex u-gap-x-[8px] u-col-start-1 u-row-start-1'>
					${drawStarEmpty()}
				</div>
				<div
					class='u-flex u-gap-x-[8px] u-col-start-1 u-row-start-1 '
					style='clip-path: inset(0 ${pourcentage}% 0 0)'
					>
						${drawStarFull()}
					</div>
					`;
			};

			const displayImg = (photos) => {
				return `<div class="u-flex u-text-blue-light">
				${photos.map((photo) => {
					const caption = photo.Caption || 'Product photo';
					return `
							<div class="u-inline">
								<div class='u-border u-w-60 u-h-60'>
									<a href="${photo.Sizes.large.Url}" target="_blank" rel="noopener noreferrer" aria-label="${caption}">
										<img class="u-w-full u-h-full" src="${photo.Sizes.thumbnail.Url}" title="${caption}" />
									</a>
								</div>
							</div>`;
				})}</div>`;
			};

			const responseClient = (ClientResponses) => {
				if (!ClientResponses.length) return ``;

				const {
					Date: ResponseDate,
					Department,
					Response,
					SourceClientName,
				} = ClientResponses[0];

				return `<div class="u-w-full t-text t-text--14 u-border u-border-grey">
					<div class="u-bg-grey-light u-flex u-justify-between u-p-10">
						<span>${Department}</span>
						<span>${formattedDate(ResponseDate)}</span>
					</div>
					<div class="u-p-10">
						<div class="u-font-semibold">${SourceClientName}</div>
						<span class="u-mt-10">${Response}</span>
					</div>
				</div>`;
			};

			const reviewElement = document.createElement('div');
			reviewElement.classList.add(
				'md:u-grid',
				'md:u-grid-cols-12',
				'u-text-blue',
				'u-gap-x-60',
				'u-gap-y-20',
				'u-py-10',
				'u-border-t',
				'u-border-blue',
			);

			const formatter = new Intl.DateTimeFormat(
				`${this.locale.replace('_', '-')}`,
				{
					day: '2-digit',
					month: '2-digit',
					year: 'numeric',
				},
			);

			const formattedDate = (date) => {
				const dateFormat = new Date(date);
				return formatter.format(dateFormat);
			};

			reviewElement.innerHTML = `
						<div class='u-hidden md:u-flex u-flex-col u-gap-y-10 u-col-start-1 u-col-end-4'>
							${
								review.UserNickname
									? `<p>${toPascalCase(review.UserNickname)}</p>`
									: 'Customer'
							}
							<span class="u-border-t u-border-blue-medium u-pt-10">${formattedDate(
								review.SubmissionTime,
							)}</span>
							${
								review.ContextDataValues.TypeOfSkin
									? `<span class="u-border-t u-border-blue-medium u-pt-10">${reviewSkin}</span>`
									: ''
							}
							${
								review.ContextDataValues.Age
									? `<span class="u-border-t u-border-blue-medium u-pt-10">${reviewAge}</span>`
									: ''
							}
							${
								reviewDateExpValue
									? `<span class="u-border-t u-border-blue-medium u-pt-10">${
											reviewDateExpLabel +
											' : ' +
											formattedDate(reviewDateExpValue)
									  }</span>`
									: ''
							}
						
						</div>
						<div class='u-grid u-gap-y-10 u-col-start-1 u-col-end-13 md:u-col-start-4'>
							<div class='u-grid u-w-fit' >
								${reviewStars(pourcentage)}
							</div>
							${
								review.ContextDataValues.TypeOfSkin
									? `<div>
												<span class='u-font-bold'>${window.reviews.skin_concern} :</span>
												<span data-translate-id=${review.Id}>${reviewSkin}</span>
											</div>`
									: ''
							}

							${
								review.ContextDataValues.Age
									? `<div>
												<span class='u-font-bold'>${window.reviews.age} :</span>
												<span data-translate-id=${review.Id}>${reviewAge}</span>
											</div>`
									: ''
							}
							${
								reviewTitle
									? `<p class='u-font-bold' data-translate-id=${review.Id}>	${reviewTitle}</p>`
									: ''
							}
							${
								reviewTexte
									? `<span data-translate-id=${review.Id}>${reviewTexte}</span>`
									: ''
							}
						
							${displayImg(review.Photos)}

							${responseClient(review.ClientResponses)}
						

							<div class="u-flex u-gap-x-20 md:u-justify-self-end">
								${
									reviewNeedTranslate
										? `<button class="t-text" data-translate data-id=${review.Id}>${window.reviews.translate_review}</button>`
										: ''
								}
								<span>${window.variantStrings.was_review_helpful}</span>
								<div class="u-flex u-gap-x-10">
									<form data-helpfulness data-id="${review.Id}">
										<input type="hidden" value="Positive" name="Vote"/>
										<input type="hidden" value="${review.Id}" name="ContentId">
										<button class="u-flex u-gap-x-5 u-items-center hover:u-underline t-button-focus" type="submit" aria-label="this review has helpful">
											<svg xmlns="http://www.w3.org/2000/svg" width="18" height="15.61" viewBox="0 0 18 15.61">
												<path class="Path_2" data-name="Path 2" d="M8.218,15.237,12.652,10.8a1.592,1.592,0,0,0,.484-1.129V1.612A1.617,1.617,0,0,0,11.523,0H4.267A1.593,1.593,0,0,0,2.816.967L.156,7.094A2.444,2.444,0,0,0,2.413,10.48h4.6L6.2,14.189a1.445,1.445,0,0,0,.322,1.129A1.247,1.247,0,0,0,8.218,15.237ZM16.36,0a1.617,1.617,0,0,0-1.612,1.612V8.062a1.612,1.612,0,0,0,3.225,0V1.612A1.617,1.617,0,0,0,16.36,0Z" transform="translate(17.973 15.61) rotate(180)" fill="rgba(136,136,136,0.25)"></path>
											</svg>
											<span>(${review.TotalPositiveFeedbackCount})</span>
										</button>
									</form>
									<form data-helpfulness data-id="${review.Id}">
										<input type="hidden" value="Negative" name="Vote"/>
										<input type="hidden" value="${review.Id}" name="ContentId">
										<button class="u-flex u-gap-x-5 u-items-center hover:u-underline t-button-focus" type="submit" aria-label="this review has not helpful">
											<svg style="transform: scale(-1)" xmlns="http://www.w3.org/2000/svg" width="18" height="15.61" viewBox="0 0 18 15.61">
													<path class="Path_2" data-name="Path 2" d="M8.218,15.237,12.652,10.8a1.592,1.592,0,0,0,.484-1.129V1.612A1.617,1.617,0,0,0,11.523,0H4.267A1.593,1.593,0,0,0,2.816.967L.156,7.094A2.444,2.444,0,0,0,2.413,10.48h4.6L6.2,14.189a1.445,1.445,0,0,0,.322,1.129A1.247,1.247,0,0,0,8.218,15.237ZM16.36,0a1.617,1.617,0,0,0-1.612,1.612V8.062a1.612,1.612,0,0,0,3.225,0V1.612A1.617,1.617,0,0,0,16.36,0Z" transform="translate(17.973 15.61) rotate(180)" fill="rgba(136,136,136,0.25)"></path>
											</svg>
											<span>(${review.TotalNegativeFeedbackCount})</span>
										</button>
									</form>
								</div>
							</div>
						</div>
					`;
			this.elementReview.appendChild(reviewElement);
		});
	}

	listenBtnPagination(ranking, rankingFilter = false) {
		if (this.data.Offset > 0) {
			this.paginationPrevElement.disabled = false;
		} else {
			this.paginationPrevElement.disabled = true;
		}
		if (this.data.TotalResults > this.data.Offset + this.data.Results.length) {
			this.paginationNextElement.disabled = false;
		} else {
			this.paginationNextElement.disabled = true;
		}

		this.paginationPrevElement.addEventListener('click', async () => {
			if (rankingFilter) {
				this.data = await this.fetchProductReviewsWithFilterRanking(
					ranking,
					this.data.Offset - 5,
				);
			} else {
				this.data = await this.fetchProductReviews(this.data.Offset - 5);
			}
			if (this.data) {
				this.initData();
				this.createReviewElement();
				this.createPaginationElement();
				this.listenSubmitFormHelpfulness();
				this.listenTranslateReview();
				this.listenBtnPagination(ranking, rankingFilter);
				window.scrollTo(0, this.elementReview.offsetTop - 120);
			}
		});
		this.paginationNextElement.addEventListener('click', async () => {
			if (rankingFilter) {
				this.data = await this.fetchProductReviewsWithFilterRanking(
					ranking,
					this.data.Offset + 5,
				);
			} else {
				this.data = await this.fetchProductReviews(this.data.Offset + 5);
			}
			if (this.data) {
				this.initData();
				this.createReviewElement();
				this.createPaginationElement();
				this.listenSubmitFormHelpfulness();
				this.listenTranslateReview();
				this.listenBtnPagination(ranking, rankingFilter);
				window.scrollTo(0, this.elementReview.offsetTop - 120);
			}
		});
	}

	createPaginationElement(ranking, rankFilter = false) {
		this.paginationElement.innerHTML = '';
		// calculate the number of pages
		let pages = Math.ceil(this.data.TotalResults / 5);

		let currentPage = Math.floor(this.data.Offset / 5);

		if (pages > 4) {
			this.contentPagination(
				currentPage,
				ranking,
				rankFilter,
				this.data,
				pages,
			);
		} else if (pages > 1) {
			// create element number of pages
			for (let i = 0; i < pages; i++) {
				let btn = this.createPageButton(i, currentPage === i);

				this.paginationElement.appendChild(btn);

				this.clickBtnPagination(btn, ranking, rankFilter, this.data, i, pages);
			}
		}
	}

	createPageButton(pageNum, isCurrent) {
		const btn = document.createElement('li');
		btn.innerHTML = pageNum + 1;
		btn.classList.add(
			'u-bg-transparent',
			'u-text-blue',
			'u-text-20-26',
			'u-p-5',
			'u-m-5',
			'u-cursor-pointer',
		);
		if (isCurrent) {
			btn.classList.add('u-underline');
			btn.setAttribute('aria-current', 'page');
		} else {
			btn.setAttribute('tabindex', '0');
		}

		return btn;
	}

	createEllipsis() {
		const span = document.createElement('li');
		span.innerHTML = '...';
		span.classList.add('u-text-blue', 'u-text-20-26', 'u-p-5', 'u-m-5');
		return span;
	}

	clickBtnPagination(btn, ranking, rankFilter, data, currentPage, pages) {
		btn.addEventListener('click', async () => {
			if (rankFilter) {
				data = await this.fetchProductReviewsWithFilterRanking(
					ranking,
					currentPage * 5,
				);
			} else {
				data = await this.fetchProductReviews(currentPage * 5);
			}
			// if selected page add class
			this.paginationElement.childNodes.forEach((el) => {
				el.classList.remove('u-underline');
				btn.removeAttribute('aria-current', 'page');
			});
			btn.classList.add('u-underline');
			btn.setAttribute('aria-current', 'page');

			this.paginationElement.innerHTML = '';
			this.contentPagination(currentPage, ranking, rankFilter, data, pages);

			// if data is fetch
			if (data) {
				this.data = data;

				this.initData();
				this.createReviewElement();
				this.listenBtnPagination(ranking, rankFilter);
				this.listenSubmitFormHelpfulness();
				this.listenTranslateReview();
				window.scrollTo(0, this.elementReview.offsetTop - 120);
			}
		});
	}

	contentPagination(currentPage, ranking, rankFilter, data, pages) {
		// Create the first page button
		let btnFirst = this.createPageButton(0, currentPage === 0);

		this.paginationElement.appendChild(btnFirst);

		this.clickBtnPagination(btnFirst, ranking, rankFilter, data, 0, pages);

		if (currentPage > 2) {
			this.paginationElement.appendChild(this.createEllipsis());
		}

		let startPage = Math.max(1, currentPage - 1);
		let endPage = Math.min(pages - 2, currentPage + 1);

		for (let i = startPage; i <= endPage; i++) {
			let btn = this.createPageButton(i, currentPage === i);

			this.paginationElement.appendChild(btn);

			this.clickBtnPagination(btn, ranking, rankFilter, data, i, pages);
		}

		if (endPage < pages - 2) {
			this.paginationElement.appendChild(this.createEllipsis());
		}

		// Create the last page button
		let btnLast = this.createPageButton(pages - 1, currentPage === pages - 1);

		this.paginationElement.appendChild(btnLast);

		this.clickBtnPagination(
			btnLast,
			ranking,
			rankFilter,
			data,
			pages - 1,
			pages,
		);
	}

	/**
	 * Attaches a click event listener to the review form toggle element.
	 * Handles the logic for displaying the review form based on user authentication and widget availability:
	 * - If account is mandatory and user is not logged in, redirects to the login page.
	 * - If a Bazaarvoice widget is available, opens the review submission widget.
	 * - Otherwise, toggles the visibility of the review form.
	 *
	 * @returns {void}
	 */
	toggleReviewForm() {
		this.toggleFormReviewElement.addEventListener('click', (e) => {
			const {routeLogin} = e.target.dataset;

			if (this.accountMandatory && !this.customerId) {
				this.redirectAccount(routeLogin);
			} else if (this.widgetBvapi) {
				BV.ui('rr', 'submit_review', {
					productId: this.id,
					campaignId: this.widgetCampaignId,
				});
			} else {
				this.formReview.classList.toggle('u-hidden');
			}
		});
	}

	redirectAccount(routeLogin) {
		const return_to = encodeURIComponent(window.location.pathname);
		const newUrl = `${
			window.location.origin + routeLogin
		}?return_url=${return_to}`;

		setTimeout(() => {
			window.location = newUrl;
		}, 3000);

		this.toggleFormReviewElement.classList.add('!u-hidden');
		this.formNeedAccount.classList.remove('u-max-h-0');
	}

	makeRankingFormReview() {
		const stars = this.formReviewStars.querySelector('[data-stars-form]');
		const allSvg = [...stars.querySelectorAll('svg')];
		const insideStars = this.formReviewStars.querySelector('[data-full-stars]');
		const nbrStars = this.formReviewStars.querySelector('span');
		const input = this.formReviewStars.querySelector('input');

		// listen click svg and calculate the number of stars
		allSvg.forEach((svg, index) => {
			svg.addEventListener('click', () => {
				// if minumum 1 star keep 1 star
				if (svg.dataset.id === 1) {
					insideStars.style.clipPath = `inset(0 80% 0 0)`;
					nbrStars.innerHTML = '1';
					input.value = '1';
					return;
				}
				insideStars.style.clipPath = `inset(0 ${
					100 - svg.dataset.id * 20
				}% 0 0)`;
				nbrStars.innerHTML = svg.dataset.id;
				input.value = svg.dataset.id;
			});
		});
		//listen mouse move and calculate the number of stars
	}

	async listenSubmitForm() {
		this.formReview.addEventListener('submit', async (e) => {
			e.preventDefault();
			const data = new FormData(this.formReview);
			const response = await this.fetchFormReviewFirstStep(data);
			if (response !== null) {
				const responseSecond = await this.fetchFormReviewSecondStep(
					response,
					data,
				);
				if (responseSecond.hasErrors === false) {
					this.formReview.reset();
					//this.formReview.classList.add('u-hidden');
					this.success.classList.remove('u-hidden');
					setTimeout(() => {
						this.success.classList.add('u-hidden');
						this.formReview.classList.add('u-hidden');
					}, 3000);
				} else {
					this.manageError(responseSecond);
					this.error.classList.remove('u-hidden');
					setTimeout(() => {
						this.error.classList.add('u-hidden');
					}, 3000);
				}
			}
		});
	}

	manageError(responseSecond) {
		const {field, message} = responseSecond.response.formValidationErrors[0];
		this.elP = this.error.querySelector('p');

		if (field == 'usernickname') {
			const original_message = this.elP.innerText;
			this.elP.innerText = message;

			setTimeout(() => {
				this.elP.innerText = original_message;
			}, 3000);
		}
	}

	helpfulnessSubmited(el, value, forms) {
		const elFormVote = el.querySelector('input[name="Vote"]').value;
		if (value !== elFormVote) return;

		const elFormPath = el.querySelector('path');
		elFormPath.style.fill = '#004D9D';

		const elSpanValue = el.querySelector('span');
		const elSpanValueNumber =
			Number(elSpanValue.innerText.replace(/\D/g, '')) + 1;
		elSpanValue.innerText = `(${elSpanValueNumber})`;

		forms.forEach((form) => {
			if (form.dataset.id === el.dataset.id) {
				form.querySelector('button').disabled = true;
			}
		});
	}

	async listenSubmitFormHelpfulness() {
		const forms = [...this.querySelectorAll('[data-helpfulness]')];

		forms.forEach((form) => {
			const isHelpfulnessValue = localStorage.getItem(form.dataset.id);

			if (isHelpfulnessValue)
				return this.helpfulnessSubmited(form, isHelpfulnessValue, forms);

			form.addEventListener('submit', async (e) => {
				e.preventDefault();
				const data = new FormData(form);
				const storage = localStorage.getItem(data.get('ContentId'));

				//find form with the same contentId

				if (storage !== null) {
					return;
				}

				const response = await this.fetchHelpfulnessReview(
					data.get('Vote'),
					data.get('ContentId'),
				);

				if (response.HasErrors === false) {
					localStorage.setItem(data.get('ContentId'), data.get('Vote'));
					this.helpfulnessSubmited(e.target, data.get('Vote'), forms);
				}
			});
		});
	}

	listenTranslateReview() {
		const elTranslates = [...this.querySelectorAll('[data-translate]')];

		elTranslates.forEach((elTranslate) => {
			elTranslate.addEventListener(
				'click',
				async (e) => {
					const textTranslates = [
						...this.querySelectorAll(
							`[data-translate-id='${e.target.dataset.id}']`,
						),
					];

					textTranslates.forEach(async (text) => {
						let text_translated = await this.translateText(text.innerText);
						text.innerHTML = text_translated;
					});

					elTranslate.remove();
				},
				{once: true},
			);
		});
	}

	/**
	 * Hides the star rating elements by adding a 'u-hidden' class.
	 *
	 */
	hideStars() {
		this.globalStarsElement.classList.add('u-hidden');

		this.globalRangeElement.forEach((el) => {
			el.classList.add('u-hidden');
		});
	}

	async translateText(text) {
		const url = 'https://translation.googleapis.com/language/translate/v2';
		const q = text;
		const key = this.keyTranslation;
		const target = this.locale;
		let translatedText;
		await fetch(`${url}?q=${q}&target=${target}&key=${key}`)
			.then((res) => res.json())
			.then((data) => {
				translatedText = data.data.translations[0].translatedText;
			});
		return translatedText;
	}

	disconnectedCallback() {}
}
